import { render, staticRenderFns } from "./formatos_pedidos.vue?vue&type=template&id=a94dcefc"
import script from "./formatos_pedidos.vue?vue&type=script&lang=js"
export * from "./formatos_pedidos.vue?vue&type=script&lang=js"
import style0 from "./formatos_pedidos.vue?vue&type=style&index=0&id=a94dcefc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports